import {
  canViewerPermission,
  getViewerEmailFromStorage,
} from "./userMatrixStorage";
import { viewerIsContractor } from "./contractorProjectAccess";

/**
 * Sidebar tools (calendar, map, settings) — default on; Contractor role defaults off
 * via User Matrix inference when the permission key is missing.
 */
function chromePermission(viewerEmail, key) {
  const email = viewerEmail ?? getViewerEmailFromStorage();
  const contractorDefaultOff = viewerIsContractor(email);
  return canViewerPermission(email, key, !contractorDefaultOff);
}

export function canAccessScheduleCalendar(viewerEmail) {
  return chromePermission(viewerEmail, "canAccessScheduleCalendar");
}

export function canAccessCommercialMap(viewerEmail) {
  return chromePermission(viewerEmail, "canAccessCommercialMap");
}

export function canAccessSettings(viewerEmail) {
  return chromePermission(viewerEmail, "canAccessSettings");
}

/** Project landing comments — off for Contractor by default. */
export function canAccessProjectComments(viewerEmail) {
  const email = viewerEmail ?? getViewerEmailFromStorage();
  if (viewerIsContractor(email)) return false;
  return true;
}
